<template>
  <span class="rf-icon" aria-hidden="true">
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" fill="none">
      <path
        fill="inherit"
        stroke="none"
        d="m14.07 24.27 6.9-8.27h-5.34l.97-7.57-6.17 8.9h4.64zm-2.63 4.32 1.33-9.26H6.6L17.6 3.47h1.64L17.91 14h7.33L13.08 28.59z"
      />
    </svg>
  </span>
</template>
